/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
/* eslint-disable react/no-danger */
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

// Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
import Text, { TEXT_TYPES } from '../text';

// Styles
import { baseStyle } from './style';

interface SideBySideTextImageProps {
  className?: string;
  imageOnLeft: boolean;
  imageDesktop: ImageType;
  imageMobile?: ImageType;
  title?: string;
  content?: string;
}

const SideBySideTextImage: FunctionComponent<SideBySideTextImageProps> = React.memo(
  ({ className, title, content, imageOnLeft, imageDesktop, imageMobile }) => {
    // Memos
    const orders = React.useMemo(() => (imageOnLeft ? [1, 2] : [2, 1]), [
      imageOnLeft,
    ]);

    const imageMobileToUse = React.useMemo(() => {
      if (imageMobile) {
        return imageMobile;
      }
      return imageDesktop;
    }, [imageDesktop, imageMobile]);

    return (
      <Flex
        className={classNames('SideBySideTextImage', className)}
        sx={baseStyle.flexContainer}
      >
        <Box
          className={orders[0] === 1 ? 'left-col' : ''}
          sx={{ ...baseStyle.imageContainer, order: orders[0] }}
        >
          <FluidImage {...imageDesktop} sx={baseStyle.image} />
        </Box>
        <Box
          className={orders[0] === 2 ? 'left-col' : ''}
          sx={{ ...baseStyle.contentContainer, order: orders[1] }}
        >
          {title && (
            <Text
              type={(TEXT_TYPES.H4, TEXT_TYPES.H3)}
              sx={baseStyle.contentTitle}
            >
              {title}
            </Text>
          )}
          {content && (
            <Text type={TEXT_TYPES.BODY_1} sx={baseStyle.contentContent}>
              <span
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            </Text>
          )}
          <Box sx={baseStyle.responsiveImageContainer}>
            <FluidImage {...imageMobileToUse} sx={baseStyle.image} />
          </Box>
        </Box>
      </Flex>
    );
  },
);

export default SideBySideTextImage;
